import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import store from "./context-store";
import "bootstrap/dist/css/bootstrap.min.css";
const basePath = "";
ReactDOM.render(
  <Provider store={store}>
    <BrowserRouter basename={basePath}>
      <React.StrictMode>
        <App />
      </React.StrictMode>
    </BrowserRouter>
  </Provider>,
  document.getElementById("root")
);
reportWebVitals();